var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTileBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 40 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 55.125C41.6435 55.1134 49.8634 46.8934 49.875 36.75V13.125C49.875 12.6 49.8409 12.0751 49.7962 11.5711C54.6157 13.6415 57.7421 18.3796 57.75 23.625V49.875C57.7414 57.1201 51.8702 62.9914 44.6251 63H28.8751C23.6297 62.9921 18.8915 59.8656 16.821 55.0462C17.3461 55.0909 17.8501 55.125 18.375 55.125H31.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46808 8.58905L13.4635 2.39671C14.1237 1.7282 14.898 1.18322 15.75 0.787506V10.5H6.1425C6.48691 9.80069 6.93369 9.15654 7.46808 8.58905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375 10.5C18.375 11.9497 17.1998 13.1249 15.75 13.1249H5.33929C5.5326 11.4205 6.2806 9.82665 7.46812 8.58893L13.4636 2.39659C14.7751 1.06719 16.5151 0.245116 18.375 0.0760498V10.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.625 10.5V0H31.5C38.7451 0.00873633 44.6163 5.87992 44.625 13.125V36.75C44.6163 43.9952 38.7451 49.8663 31.5 49.8751H18.3749C11.1298 49.8663 5.25861 43.9952 5.24987 36.75V18.375H15.75C20.0992 18.375 23.625 14.8493 23.625 10.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileBg);
export default __webpack_public_path__ + "static/media/tile-bg.90e12aa494048edcc02e064b298447dd.svg";
export { ForwardRef as ReactComponent };